import type { GetMedicalInstitutions200Response } from '@/src/api/medicalInstitutions';
import { defineStore } from 'pinia';

export type MedicalInstitution =
  GetMedicalInstitutions200Response['medicalInstitutions'][number];
type State = GetMedicalInstitutions200Response;

export const useMedicalInstitutionList = defineStore(
  'medical_institution/list',
  {
    state: (): State => ({
      lastUpdatedAt: '',
      medicalInstitutions: [],
    }),
    actions: {
      async fetchMedicalInstitutions() {
        try {
          const response =
            await this.$api.medicalInstitutionsApi.getMedicalInstitutions();
          this.lastUpdatedAt = response.data.lastUpdatedAt;
          this.medicalInstitutions = response.data.medicalInstitutions;
          return true;
        } catch {
          return false;
        }
      },
    },
  },
);
